// extracted by mini-css-extract-plugin
module.exports = {"audioPlayer":"audio-player_audioPlayer__1QptY"};